/**
 * `/code-review/summaries` — *PR Summaries* section.
 */
import { SettingsForm } from '../../components/SettingsForm.js';

export default function CodeReviewSummaries() {
  return (
    <main className="feluda-settings">
      <SettingsForm
        section="summaries"
        title="PR Summaries"
        subtitle="Shape the body of Feluda's review comments."
      />
    </main>
  );
}
